var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import { components } from './components/components';
import { useCustomElement } from './use-custom-element';
import { slotTranslation } from './slot-translation';
import { camelToHyphenated } from '../utils/helpers';
export var resetClassName = function (prevEl, prevClass) {
    var prevElClass = [];
    var prevClassArr = [];
    prevClass.split(' ').forEach(function (name) { return prevClassArr.push(name); });
    prevEl.className.split(' ').forEach(function (name) { return prevElClass.push(name); });
    if (prevClassArr.length > 0 && prevElClass.length > 0) {
        prevClassArr.forEach(function (name) {
            var i = prevElClass.indexOf(name);
            if (i > -1)
                prevElClass.splice(i, 1);
        });
    }
    return prevElClass;
};
export var camelHyphenateMap = function (props) {
    var propMap = {};
    Object.keys(props).forEach(function (prop) {
        var propHeyphenated = camelToHyphenated(prop);
        if (prop !== propHeyphenated) {
            propMap[prop] = propHeyphenated;
        }
    });
    return propMap;
};
export var getComponentConfig = function (tagName) {
    return components.filter(function (item) { return item.name === tagName; })[0]
        ? components.filter(function (item) { return item.name === tagName; })[0]
        : {};
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var createReactWrapper = function (TagName, shadow) {
    var advancedPropMap, preserveMarkup;
    var componentConfig = getComponentConfig(TagName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var ReactWrapper = function (props) {
        var children = props.children, wcref = props.wcref, className = props.className, otherProps = __rest(props, ["children", "wcref", "className"]);
        var propMap = camelHyphenateMap(otherProps);
        if (componentConfig) {
            advancedPropMap = componentConfig.advancedPropMapping;
            preserveMarkup = componentConfig.preserveMarkup;
        }
        var _a = useCustomElement(otherProps, __assign(__assign({}, propMap), advancedPropMap), wcref), customElementProps = _a[0], ref = _a[1];
        // className prop provided from React Wrappers needs to be added along side classes provided by Stencil.
        var prevClassName = React.useRef();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var prevRef = React.useRef();
        React.useEffect(function () {
            prevClassName.current = className;
            prevRef.current = ref.current;
        });
        // The following allows className prop to be toggled without overriding stencil classes which are set asyncronsly
        var resetClassArr = [];
        if (prevClassName.current && prevRef.current) {
            resetClassArr = resetClassName(prevRef.current, prevClassName.current);
        }
        else if (prevRef.current) {
            resetClassArr = prevRef.current.className.split(' ');
        }
        var newClassNames = [];
        if (className)
            className.split(' ').forEach(function (name) { return newClassNames.push(name); });
        var formulatedClass = __spreadArrays(newClassNames, resetClassArr);
        return (React.createElement(TagName, __assign({}, customElementProps, { class: formulatedClass.join(' '), ref: ref }), shadow || preserveMarkup
            ? children
            : slotTranslation(children)));
    };
    return ReactWrapper;
};
//# sourceMappingURL=create-react-wrappers.js.map